(function () {
  var root = document.documentElement;

  /* ---------- the hero is exactly one screen ---------- */
  function setChrome() {
    var a = document.querySelector('.announce');
    var h = document.querySelector('.header');
    root.style.setProperty('--chrome', ((a ? a.offsetHeight : 0) + (h ? h.offsetHeight : 0)) + 'px');
  }
  setChrome();
  window.addEventListener('resize', setChrome);
  window.addEventListener('load', setChrome);

  /* ---------- light / dark ---------- */
  var bLight = document.getElementById('theme-light');
  var bDark = document.getElementById('theme-dark');
  function read() { try { return localStorage.getItem('kgps-theme'); } catch (e) { return null; } }
  function save(v) { try { v ? localStorage.setItem('kgps-theme', v) : localStorage.removeItem('kgps-theme'); } catch (e) {} }
  function paint(choice) {
    var system = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    var active = choice || root.getAttribute('data-theme') || system;
    bLight.setAttribute('aria-pressed', String(active !== 'dark'));
    bDark.setAttribute('aria-pressed', String(active === 'dark'));
  }
  function set(choice) { root.setAttribute('data-theme', choice); save(choice); paint(choice); }
  var stored = read();
  if (stored === 'dark' || stored === 'light') root.setAttribute('data-theme', stored);
  paint(stored);
  bLight.addEventListener('click', function () { set('light'); });
  bDark.addEventListener('click', function () { set('dark'); });
  if (window.matchMedia) {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function () {
      if (!read()) paint(null);
    });
  }

  /* ---------- photo fallback ----------
     Drop a photo that cannot load so the drawing beneath shows through
     instead of a broken-image box. The two are never on screen together. */
  function dropPhoto(img) {
    var slot = img.parentElement;
    if (slot) slot.classList.add('no-photo');
    img.remove();
  }
  function checkPhoto(img) { if (img.complete && img.naturalWidth === 0) dropPhoto(img); }
  var photos = Array.prototype.slice.call(document.querySelectorAll('img.ph, img.phx'));
  photos.forEach(function (img) {
    img.addEventListener('error', function () { dropPhoto(img); });
    checkPhoto(img);
  });
  window.addEventListener('load', function () { photos.forEach(checkPhoto); });

  /* ---------- section reveals ----------
     One observer for both kinds. Everything starts hidden only when .js-anim
     is set, and if the browser has no IntersectionObserver every target is
     revealed immediately rather than left invisible. */
  var targets = Array.prototype.slice.call(document.querySelectorAll('[data-reveal], [data-stagger]'));
  document.querySelectorAll('[data-stagger]').forEach(function (group) {
    Array.prototype.forEach.call(group.children, function (kid, i) {
      kid.style.setProperty('--i', i);
    });
  });
  if ('IntersectionObserver' in window && targets.length) {
    var revealer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        revealer.unobserve(e.target);   /* it only arrives once */
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    targets.forEach(function (t) { revealer.observe(t); });
  } else {
    targets.forEach(function (t) { t.classList.add('in'); });
  }

  /* ---------- reviews carousel ----------
     The track does the scrolling; this only drives the buttons and the dots,
     and keeps them in step with however the reader actually moved — finger,
     trackpad, keyboard or button. With this script absent the track is still
     a scrollable list, which is why it is built this way round. */
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('.car-track');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var dotBox = root.querySelector('[data-dots]');
    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;

    function perView() {
      var w = slides[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return Math.max(1, Math.round((track.clientWidth + gap) / (w + gap)));
    }
    function pageCount() { return Math.max(1, slides.length - perView() + 1); }
    function index() {
      var w = slides[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return Math.round(track.scrollLeft / (w + gap));
    }

    var dots = [];
    function buildDots() {
      dotBox.textContent = '';
      dots = [];
      for (var i = 0; i < pageCount(); i++) {
        (function (i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to review ' + (i + 1));
          b.addEventListener('click', function () { goTo(i); });
          dotBox.appendChild(b);
          dots.push(b);
        })(i);
      }
    }
    function goTo(i) {
      var w = slides[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollTo({ left: i * (w + gap), behavior: 'smooth' });
    }
    function sync() {
      var i = index();
      var last = pageCount() - 1;
      prev.disabled = i <= 0;
      next.disabled = i >= last;
      dots.forEach(function (d, n) { d.setAttribute('aria-current', String(n === i)); });
    }

    prev.addEventListener('click', function () { goTo(Math.max(0, index() - 1)); });
    next.addEventListener('click', function () { goTo(Math.min(pageCount() - 1, index() + 1)); });

    var tick;
    track.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(sync, 90);
    });
    window.addEventListener('resize', function () { buildDots(); sync(); });

    buildDots();
    sync();
  });

  /* ---------- the sticky buy bar ----------
     Follows whichever card is most in view, and only while a card is in view:
     no bar over the hero, none over the footer. */
  var bar = document.getElementById('sticky-buy');
  var barName = document.getElementById('sb-name');
  var barPrice = document.getElementById('sb-price');
  var cards = Array.prototype.slice.call(document.querySelectorAll('.card'));
  if (bar && cards.length && 'IntersectionObserver' in window) {
    var ratios = new Map();
    var current = null;

    function priceOf(card) {
      var amount = card.querySelector('.amount');
      var plan = card.querySelector('.price-plan');
      if (!amount) return '';
      var note = plan ? plan.textContent.trim() : '';
      if (/month/i.test(note)) return amount.textContent.trim() + ' + $8.95/mo';
      return amount.textContent.trim() + ' · no monthly fee';
    }

    function show(card) {
      if (card === current) return;
      current = card;
      barName.textContent = card.querySelector('.card-title').textContent.trim();
      barPrice.textContent = priceOf(card);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { ratios.set(e.target, e.intersectionRatio); });
      var best = null, bestRatio = 0;
      ratios.forEach(function (r, el) { if (r > bestRatio) { bestRatio = r; best = el; } });
      if (best && bestRatio > 0.25) {
        show(best);
        bar.dataset.show = 'true';
        bar.setAttribute('aria-hidden', 'false');
      } else {
        bar.dataset.show = 'false';
        bar.setAttribute('aria-hidden', 'true');
      }
    }, { threshold: [0, 0.25, 0.5, 0.75, 1] });

    cards.forEach(function (c) { io.observe(c); });

    document.getElementById('sb-add').addEventListener('click', function () {
      if (current) current.querySelector('.atc').click();
    });
  }
})();
